import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import VideoWithTool from './VideoWithTool.vue';
import { normalizeVideoWidth } from './videoUploadCore';
export var VideoWithTools = Node.create({
    name: 'video',
    group: 'block',
    atom: true,
    draggable: true,
    selectable: true,
    addOptions: function () {
        return {
            HTMLAttributes: {
                class: 'edoovo-rich-video'
            }
        };
    },
    addAttributes: function () {
        return {
            src: {
                default: null
            },
            poster: {
                default: null
            },
            width: {
                default: 'auto',
                parseHTML: function (element) { return normalizeVideoWidth(element.getAttribute('width')); },
                renderHTML: function (attributes) {
                    var width = normalizeVideoWidth(attributes.width);
                    return width === 'auto' ? {} : { width: width.replace('px', '') };
                }
            },
            controls: {
                default: true,
                parseHTML: function () { return true; },
                renderHTML: function () { return ({ controls: '' }); }
            },
            playsinline: {
                default: true,
                parseHTML: function () { return true; },
                renderHTML: function () { return ({ playsinline: '' }); }
            },
            preload: {
                default: 'metadata'
            }
        };
    },
    parseHTML: function () {
        return [
            {
                tag: 'video[src]:not([src^="data:"]):not([src^="blob:"])'
            }
        ];
    },
    renderHTML: function (_a) {
        var HTMLAttributes = _a.HTMLAttributes;
        return [
            'video',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                style: 'max-width: 100%; height: auto; display: block;'
            })
        ];
    },
    addCommands: function () {
        var _this = this;
        return {
            setVideo: function (options) {
                return function (_a) {
                    var commands = _a.commands;
                    return commands.insertContent([
                        {
                            type: _this.name,
                            attrs: {
                                src: options.src,
                                poster: options.poster || null,
                                width: normalizeVideoWidth(options.width || 'auto'),
                                controls: true,
                                playsinline: true,
                                preload: 'metadata'
                            }
                        },
                        {
                            type: 'paragraph'
                        }
                    ]);
                };
            }
        };
    },
    addNodeView: function () {
        return VueNodeViewRenderer(VideoWithTool);
    }
});
